import { Card } from "@acme/ui/card";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import SearchResultsPage from "~/features/search-results/_components/search-results-page.js";
import { useClanSearchAuth } from "../route.js";
import { canReadClanPlayerSearchResults } from "~/features/clan-detail/_utils/clan-tab-routes.js";

export const Route = createFileRoute("/_authed/my-clans/$tag/player-search/results")({
  component: ClanPlayerSearchResultsTab,
});

function ClanPlayerSearchResultsTab() {
  const { t } = useTranslation();
  const { auth, isReady, effectivePermissions } = useClanSearchAuth();

  if (!isReady || auth == null) return null;

  if (!canReadClanPlayerSearchResults(effectivePermissions)) {
    return (
      <Card className="p-6">
        <p className="text-center text-muted-foreground py-6">{t("app.clanDetail.noPermission")}</p>
      </Card>
    );
  }

  return <SearchResultsPage auth={auth} scope="clan" />;
}
